import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// No redux store and no session-timeout wrapper: both belong to the internal
// portal. Applicants authenticate with their own token, held by careerApi.js
// and unrelated to the Hive JWT.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
